import service from "@/store/services/users-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  listLight: {},
  user: {},
  meta: {},
  url: null,
  empleados: [],
  kpis: {},
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_LIST_LIGHT: (state, listLight) => {
    state.listLight = listLight;
  },
  SET_RESOURCE: (state, user) => {
    state.user = user;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
  SET_EMPLEADOS(state, empleados) {
    state.empleados = empleados;
  },
  SET_KPI_EMPLEADOS(state, kpis) {
    state.kpis = kpis;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  listLight({ commit, dispatch }, params = {}) {
    return service
      .listLight(params, this.$axios)
      .then(({ listLight, meta }) => {
        commit("SET_LIST_LIGHT", listLight);
      });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((user) => {
      commit("SET_RESOURCE", user);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((user) => {
      commit("SET_RESOURCE", user);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((user) => {
      commit("SET_RESOURCE", user);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((user) => {
      commit("SET_RESOURCE", user);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  upload({ commit, dispatch }, { user, image }) {
    return service.upload(user, image, this.$axios).then((url) => {
      commit("SET_URL", url);
    });
  },
  fetchEmpleados({ commit, dispatch }, params = {}) {
    return service.fetchEmpleados(params, this.$axios).then((data) => {
      commit("SET_EMPLEADOS", data.empleados || []);
      commit("SET_KPI_EMPLEADOS", data.kpis || {});
    });
  },
};

const getters = {
  list: (state) => state.list,
  listLight: (state) => state.listLight,
  listTotal: (state) => state.list.length,
  user: (state) => state.user,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((user) => ({
      id: user.id,
      nombre: user.nombre + " " + user.apellidos + " (" + user.username + ")",
      apellidos: user.apellidos,
      username: user.username,
      empresas: user.empresas,
    }));
  },
  dropdownLight: (state) => {
    return state.listLight.map((user) => ({
      id: user.id,
      nombre: user.nombre + " " + user.apellidos + " (" + user.username + ")",
      apellidos: user.apellidos,
      username: user.username,
      empresas: user.empresas,
    }));
  },
  empleados: (state) => state.empleados,
  kpis: (state) => state.kpis,
};

const users = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default users;
